// extracted by css-extract-rspack-plugin
export default {"cls1":"ChatInterface-cls1_kGD","cls2":"ChatInterface-cls2_Z3S ChatInterface-cls1_kGD"};